<template>
  <div>
    <h3 class="pt-0 mt-0 pb-0">{{ $t("viewSettings.sms_gateways.title") }}</h3>
    <v-data-iterator
      :items="smsGateways"
      row
      item-key="name"
      :options="{ itemsPerPage: 1000 }"
      wrap
      hide-default-footer

    >
      <template v-slot:default="{ items, isExpanded, expand }">
        <v-row>
          <v-col v-for="item in items" sm="12" md="6" lg="4" class="py-0">
            <v-card
              elevation="1"
              :loading="isSaving.includes(item.id)"
              :disabled="isSaving.includes(item.id)"
            >
              <v-toolbar
                @click="
                  () => {
                    expand(item, !isExpanded(item));
                  }
                "
                class="mt-2 pointer"
                elevation="0"
              >
                <template
                  v-if="
                    parseInt(defaultSmsGatewayId)===parseInt(item.id)
                  "
                >
                  <v-icon color="success" text-color="success" left
                    >fa-check-circle</v-icon
                  >
                </template>
                <template v-else>
                  <v-icon color="red" text-color="red" left
                    >fa-times-circle
                  </v-icon>
                </template>
                <v-toolbar-title>
                  <span>{{ item.name }}</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <div v-if="isExpanded(item)" mode="scale-transition">
                <v-form
                  lazy-validation
                  class="pa-2"
                  v-if="!item.nowSave"
                  :ref="'form' + item.name"
                >
                  <a :href="item.website" target="_blank" class="mb-3 d-block">{{item.website}}</a>
                  <template v-for="(field) in item.credentials_fields">
                    <v-text-field
                        :disabled="!fetched"
                        :label="field"
                        aria-selected="true"
                        v-model="shopSmsGatewayParams[item.id][field]"
                    ></v-text-field>
                  </template>
                  <v-switch
                      :disabled="!fetched"
                      :value-comparator="()=>parseInt(defaultSmsGatewayId)===parseInt(item.id)"
                      @change="isDefault=>saveSmsGatewayParameters(item, isDefault)"
                      :label="$t('common.default')"
                      :value="true"
                  >
                  </v-switch>
                </v-form>
                <v-card-actions>
                  <v-btn
                    text
                    :disabled="!fetched"
                    :loading="!fetched"
                    @click="saveSmsGatewayParameters(item, parseInt(defaultSmsGatewayId)===parseInt(item.id))"
                  >
                    {{ $t("common.save") }}
                  </v-btn>
                  <v-btn
                    text
                    :disabled="!fetched|| parseInt(defaultSmsGatewayId)!==parseInt(item.id)"
                    :loading="!fetched"
                    @click="saveSmsGatewayParameters(item, parseInt(defaultSmsGatewayId)===parseInt(item.id)).then(()=>testDefaultWindow.isVisible=true)"
                  >
                    {{ $t("viewSettings.sms_templates.test") }}
                  </v-btn>
                </v-card-actions>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
    <v-dialog>
      testDefaultWindow
    </v-dialog>
    <v-dialog v-model="testDefaultWindow.isVisible" scrollable max-width="350px" persistent>
      <v-card>
        <v-card-actions>
          <h3 class="pl-2">
            {{ $t("viewSettings.sms_templates.test") }}
          </h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="testDefaultWindow.isVisible = false; testDefaultWindow.result=null">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <v-form ref="test">
            <v-text-field
                outlined
                placeholder="79991111111"
                :placeholder="$t('viewSettings.sms_templates.phone_placeholder')"
                :loading="isLoading"
                :rules="[
                  (v) => !!v || $t('form.validationErrors.field_is_required'),
                  (v) => (v && v.length>10) ||$t('form.validationErrors.minLength', [10])
                ]"
                v-model="testDefaultWindow.phone"
                :label="$t('common.phone')"
            ></v-text-field>
            <v-text-field
                outlined
                :loading="isLoading"
                :rules="[
                  (v) => !!v || $t('form.validationErrors.field_is_required'),
                ]"
                :value="testDefaultWindow.text"
                v-model="testDefaultWindow.text"
                :label="$t('viewSettings.sms_templates.text')"
            ></v-text-field>
<pre>
{{testDefaultWindow.result}}
</pre>
          </v-form>
          <v-divider class="mt-4"></v-divider>
          <v-card-actions class="pa-0 mx-0">
            <v-spacer></v-spacer>
            <v-btn
                :loading="isLoading"
                :disabled="isLoading"
                class="mt-5"
                color="primary"
                @click="test"
                @keyup.enter="test"
                elevation="0"
            >
              {{ $t("viewSettings.sms_templates.test") }}
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import router from "../../router";

export default {
  name: "SmsGateways",
  data: () => ({
    isSaving: [],
    shopSmsGatewayParams: {},
    defaultSmsGatewayId: null,
    testDefaultWindow:{
      isVisible: false,
      phone:null,
      text:null,
      result:null
    }
  }),
  created() {
    this.onLoad();
  },
  computed: {
    ...mapFields("sms_gateways", ["smsGateways", "shopSmsGateways", "fetched"]),
    ...mapFields("auth", ["authenticatedUser"]),
    ...mapFields("sms_templates", ["isLoading"]),
  },
  watch: {
    $route(to, from) {
      this.onLoad();
    },
  },
  methods: {
    onLoad() {
      this.$store.dispatch("sms_gateways/get").then(()=>{
        this.$store.dispatch("sms_gateways/getShopSmsGateways",{shop_id:this.authenticatedUser.active_shop_id});
      }).then(()=>{
        this.smsGateways.forEach((common)=>{

          //параметры для smsgateway в текущем Shop
          let shopSmsGateway = this.shopSmsGateways.find(one=>one.id===common.id);

          if(shopSmsGateway && shopSmsGateway.pivot && shopSmsGateway.pivot && shopSmsGateway.pivot['is_default']) {
            this.defaultSmsGatewayId = common.id;
          }
          common.credentials_fields.forEach((field)=>{
            if(!this.shopSmsGatewayParams[common.id]){
              this.shopSmsGatewayParams[common.id] = {}
            }
            let value = shopSmsGateway && shopSmsGateway.pivot && shopSmsGateway.pivot.credentials && shopSmsGateway.pivot.credentials[field] || null
            this.shopSmsGatewayParams[common.id][field]=value || null;
          })

        })
      })
    },
    saveSmsGatewayParameters: function (smsGateway, isDefault) {
      if(isDefault===true){
        this.defaultSmsGatewayId = smsGateway.id;
      } else {
        this.defaultSmsGatewayId = null;
      }
      let credentials = this.shopSmsGatewayParams[smsGateway.id];
      return this.$store.dispatch("sms_gateways/updateShopSmsGateways", {
        sms_gateway_id: smsGateway.id,
        shop_id: this.authenticatedUser.active_shop_id,
        credentials,
        isDefault
      })

    },
    test() {
      if (this.$refs["test"].validate()) {
        this.$store.dispatch("sms_templates/test", {
          text: this.testDefaultWindow.text,
          phone: this.testDefaultWindow.phone
        }).then((res)=>{
          this.testDefaultWindow.result = res;
        })
      }
    },
  },
};
</script>

<style scoped></style>
